import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_109: FaireProductEntity = {
  token: "legacy_prod_abbott-109",
  type: "product",
  name: "Olive Branch Planter",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/fd6c062baa5c8b13b54d98548eeae74b21bc765451471f59ef2df0ffcf5f5000.jpeg",
  priceDollars: 24,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
